<template>
  <header class="header fixed">
    <div class="header_content">
      <router-link :to="{name:'magazine',params:{ id: $route.params.id }}" @click="menuHide()" class="logo">
        <img :src="require('@/assets/' + logo)" :alt="title" class="object-contain">
      </router-link>

      <input type="checkbox" class="menu-btn" id="menu-btn" v-model="ismenu"/>
      <label class="menu-icon cursor-pointer inline-block relative" for="menu-btn"><span class="navicon"></span></label>
      <ul class="magzineMenuUl" :class="{ menuShow : !ismenu }">
        <li v-for="(item,index) in data" :key="index" class="menu_li border-b w-75 mx-auto">
          <router-link :to="{ name:'magazine', params:{ id:item.id } }" class="border-right-0 cursor-pointer" @click="menuHide(item)">
            <div class="flex justify-center">
              <div class="text-left headerWidth text-lg">
                <h5 v-if="item.unit !== ''" :class="{ 'onunit': routeId === item.id }">
                  <span :class="{ 'hidden': isNaN(Number(item.unit)) }">Unit</span>
                  {{ item.unit }}
                </h5>
                <p :class="{ 'onunit': routeId === item.id }" v-if="item.nameEn !== ''">
                  <span v-html="item.nameEn"></span>
                </p>
                <p :class="{ 'onunit': routeId === item.id }">
                  <span>{{ item.name }}</span>
                </p>
              </div>
            </div>
          </router-link>
        </li>
      </ul>

    </div>
  </header>
</template>

<script>
  import { ref, watch, onMounted } from 'vue'
  export default {
    name: 'headerSection',
    props: {
      data: {
        type: Array,
        required: true
      },
      logo: {
        type: String,
        required: true
      },
      routeId: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      RouteIdHideMenu: {
        type: String,
        required: true
      }
    },

    setup(props, { emit }) {
      const ismenu = ref(true)

      // Watch for changes in the 'ismenu' state and emit 'hideMenu' event accordingly
      watch(ismenu, (val) => {
        emit('hideMenu', !val)
      }, { immediate: true })

      // Method to hide the menu
      const menuHide = () => {
        ismenu.value = false
      }

      // Check if the RouteIdHideMenu prop is provided
      const hasRouteId = () => {
        ismenu.value = !props.RouteIdHideMenu
      }

      // Run on component mount
      onMounted(() => {
        hasRouteId()
      })

      return {
        ismenu,
        menuHide
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    // max-width: 1400px;
    width: 100%;
    z-index: 49;
    // position: relative;
    left: 0;
    top: 0;
    height: 80px;
    background-position: center;
    background-image: url('@/assets/pic_head_bg.png');
    background-size: cover;
    .header_content {
      position: relative;
      top: 0;
      height: 100%;
      left: 0;
      .logo {
          display: inline-block;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          height: 23px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        // overflow: hidden;
        background-color: #fff;
        li {
          a {
            display: block;
            padding: 20px 20px;
            border-right: 1px solid #f4f4f4;
            text-decoration: none;
            color: #000;
            text-align: center;
            h5 {
              font-family: 'Arial', '微軟正黑體';
              font-weight: 500;
            }
            p {
              margin: 0 !important;
              font-weight: 400;
              font-family: 'Arial', '微軟正黑體';
              span {
                white-space: pre-wrap;
              }
            }
          }
          .headerWidth {
            width: 100%;
            max-width: 250px;
          }
        }
      }
    }
  }

  /* menu */
  .header .magzineMenuUl {
    clear: both;
    transition: max-height .3s ease-out;
    overflow-y: scroll;
    height: calc(100vh - 80px);
  }
  .menuShow {
    max-height: 0;
  }

  /* menu icon */
  .header {
    .menu-icon {
      float: right;
      padding: 39px 30px;
      user-select: none;
      margin: 0;
      .navicon {
        background: rgb(255, 255, 255);
        display: block;
        height: 2px;
        position: relative;
        transition: .2s ease-out;
        width: 18px;
      }
    }
  }

  .header .menu-icon .navicon:before,
  .header .menu-icon .navicon:after {
    background: rgb(255, 255, 255);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    transition: all .2s ease-out;
    width: 100%;
  }

  .header .menu-icon .navicon:before {
    top: 5px;
  }
  .header .menu-icon .navicon:after {
    top: -5px;
  }

  /* menu btn */
  .header {
    .menu-btn {
      display: none;
    }
  }
  .header .menu-btn:checked ~ .menu {
    max-height: calc(100vh - 80px);
    min-height: calc(100vh - 80px);
    overflow: scroll;
    overflow-x: hidden;
  }
  .header .menu-btn:checked ~ .menu::-webkit-scrollbar {
    display: none;
  }
  enu-btn:checked ~ .menu-icon .navicon {
    background: transparent;
  }
  .header .menu-btn:checked ~ .menu-icon .navicon {
    background: transparent;
  }
  .header .menu-btn:checked ~ .menu-icon .navicon:before {
    transform: rotate(-45deg);
  }
  .header .menu-btn:checked ~ .menu-icon .navicon:after {
    transform: rotate(45deg);
  }
  .header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
  .header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
    top: 0;
  }

  @media (width: 100em) {
    .header li {
      float: left;
      a {
        padding: 20px 30px;
      }
    }
    .header {
      .magzineMenuUl {
        clear: none;
        float: right;
        max-height: none;

      }
      .menu-icon {
        display: none;
      }
    }
  }
  .onunit {
    color: #ff3a3a !important;
  }
  .textHide {
    display: none;
  }
</style>
